import { render, staticRenderFns } from "./CoozzyDropdownItem.vue?vue&type=template&id=3219daae&scoped=true"
import script from "./CoozzyDropdownItem.vue?vue&type=script&lang=js"
export * from "./CoozzyDropdownItem.vue?vue&type=script&lang=js"
import style0 from "./CoozzyDropdownItem.vue?vue&type=style&index=0&id=3219daae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3219daae",
  null
  
)

export default component.exports